import { ErrorTypes } from '@wix/form-validator';
import { deserializeDate } from '../date-picker/helpers';
import { SupportedDateParts } from '../../utils/date-format-parts';
export const parseDateTimeValue = value => {
  if (!value) {
    return ['', ''];
  }
  const separator = value.indexOf('T') > -1 ? 'T' : ' ';
  const [date, time] = value.split(separator);
  return [date, time];
};
export const formatDateTimeValue = (date, time) => `${date ?? ''}T${time ?? ''}`;
export const isIncompleteTime = time => {
  if (!time) {
    return true;
  }
  const [hours, minutes] = time.split(':');
  return !hours || !minutes;
};
export let DateTimeFieldErrorSuffix = /*#__PURE__*/function (DateTimeFieldErrorSuffix) {
  DateTimeFieldErrorSuffix["YEAR_MONTH_TIME"] = "year-month-time";
  DateTimeFieldErrorSuffix["YEAR_DAY_TIME"] = "year-day-time";
  DateTimeFieldErrorSuffix["MONTH_DAY_TIME"] = "month-day-time";
  DateTimeFieldErrorSuffix["YEAR_TIME"] = "year-time";
  DateTimeFieldErrorSuffix["MONTH_TIME"] = "month-time";
  DateTimeFieldErrorSuffix["DAY_TIME"] = "day-time";
  DateTimeFieldErrorSuffix["TIME"] = "time";
  return DateTimeFieldErrorSuffix;
}({});
export const getDateTimePartsErrors = (hasError, value) => {
  const [date, time] = parseDateTimeValue(value);
  const {
    YEAR,
    MONTH,
    DAY
  } = deserializeDate(date);
  const invalidParts = [(YEAR == null ? void 0 : YEAR.length) !== 4, !MONTH, !DAY, isIncompleteTime(time)];
  const allValidParts = !invalidParts.some(Boolean);
  return {
    [SupportedDateParts.YEAR]: hasError && (allValidParts || invalidParts[0]),
    [SupportedDateParts.MONTH]: hasError && (allValidParts || invalidParts[1]),
    [SupportedDateParts.DAY]: hasError && (allValidParts || invalidParts[2]),
    TIME: hasError && (allValidParts || invalidParts[3])
  };
};
const isDateTimeFieldValidationError = error => {
  return (error == null ? void 0 : error.errorType) === ErrorTypes.INCOMPLETE_DATE_ERROR;
};
export const getDateTimeValidationErrorSuffix = error => isDateTimeFieldValidationError(error) ? error.params.suffix : undefined;
//# sourceMappingURL=date-time-field-utils.js.map